<template>
  <div class="detail-container">
    <div class="detail-header">
      <mtdm-navigation-bar :title="$getText('wenshu_mobile_alert_details', '告警详情')" @click-left="back" :fixed="true"></mtdm-navigation-bar>
    </div>
    <div style="height: 52px;padding-bottom: 8px;background: #F5F5F5"></div>
    <!-- 按钮组 -->
    <div class="search-block">
      <div style="float: right">
        <mtdm-button class="search-btn" icon="mtdmicon-search" type="text-primary" size="small"
                     @click="searchShow = true" style="border-right: 1px solid black">
          {{ $getText('wenshu_mobile_search_documents', '搜索文档') }}
        </mtdm-button>
        <span style="color: rgba(0,0,0,0.60);">|</span>
        <mtdm-button class="search-btn screen-btn" icon="mtdmicon-filter-o" type="text-primary" size="small"
                     @click="screenShow = true">
          {{ $getText('wenshu_mobile_filter', '筛选') }}
        </mtdm-button>
      </div>
    </div>
    <!-- 筛选表单 -->
    <mtdm-popup v-model="screenShow" position="top" :customStyle="{ 'height': '40%' }">
      <div style="height: 8px;background: #F5F5F5"></div>
      <div style="padding: 16px">
        <div class="screen-title">
          <mtd-row>
            <mtd-col :span="19">
              <span class="screen-title-font">{{ $getText('wenshu_mobile_please_select_filter_criteria', '请选择筛选条件') }}</span>
              <span style="color: rgba(0,0,0,0.60);float: right">|</span>
            </mtd-col>
            <mtd-col :span="5">
              <mtdm-button icon="mtdmicon-filter-o" type="text-primary" size="small">{{ $getText('wenshu_mobile_filter', '筛选') }}</mtdm-button>
            </mtd-col>
          </mtd-row>
          <mtd-form ref="screenForm" label-position="top">
            <mtd-row>
              <mtd-col :span="24">
                <mtd-form-item :label="$getText('wenshu_mobile_operation_type', '操作类型')">
                  <div @click="operateTypeShow = true" class="select-div">
                    <span style="line-height: 32px">{{ operateTypeValue }}</span>
                    <div style="float: right;font-size: 25px;padding: 4px 0">
                      <mtd-icon name="down-thick"></mtd-icon>
                    </div>
                  </div>
                </mtd-form-item>
              </mtd-col>
            </mtd-row>
            <mtd-row>
              <mtd-col :span="24">
                <mtd-form-item :label="$getText('wenshu_mobile_operation_time', '操作时间')">
                  <div @click="operateDateShow = true" class="select-div">
                    <span style="line-height: 32px">{{ operateDateValue }}</span>
                    <div style="float: right;font-size: 25px;padding: 4px 0">
                      <mtd-icon name="down-thick"></mtd-icon>
                    </div>
                  </div>
                </mtd-form-item>
              </mtd-col>
            </mtd-row>
            <mtd-row type="flex" justify="space-between">
              <mtd-col :span="10">
                <mtdm-button type="secondary" style="width: 100%" @click="reset">{{ $getText('wenshu_mobile_reset', '重置') }}</mtdm-button>
              </mtd-col>
              <mtd-col :span="10">
                <mtdm-button type="primary" style="width: 100%" @click="reloadFirstPage">{{ $getText('ws_mobile_confirm', '确定') }}</mtdm-button>
              </mtd-col>
            </mtd-row>
          </mtd-form>
        </div>
      </div>
    </mtdm-popup>
    <!-- 操作类型选择 -->
    <mtdm-scrollpicker v-model="operateTypeShow" :options="options" :value="query_params.operateTypeShow"
                       :confirm-text="$getText('ws_mobile_confirm', '确定')"
                       :cancel-text="$getText('wenshu_mobile_cancel', '取消')"
                       @confirm="confirm"/>
    <!-- 时间选择-->
    <mtdm-calendar v-model="operateDateShow" :title="$getText('wenshu_mobile_please_select_operation_time', '选择日期')"
                   :min-date="minDate" :showHoliday="true" :showVacation="true"
                   @confirm="dateConfirm"/>
    <!--   搜索   -->
    <mtdm-popup v-model="searchShow" position="top" :customStyle="{ 'height': '60px' }">
      <div style="height: 8px;background: #F5F5F5"></div>
      <div style="padding: 8px 16px">
        <mtd-row>
          <mtd-col :span="20">
            <mtd-input prefix-icon="mtdicon mtdicon-search" v-model="query_params.fileNameLike"
                       :placeholder="$getText('wenshu_mobile_please_enter_file_name', '请输入文件名')"
                       style="border-radius: 10px;width: 100%" @enter="reloadFirstPage"/>
          </mtd-col>
          <mtd-col :span="4">
            <mtd-button type="text-primary" @click="searchShow = false" style="padding-left: 16px">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtd-button>
          </mtd-col>
        </mtd-row>
      </div>
    </mtdm-popup>
    <div class="detail-card">
      <mtd-card v-for="item in alarm_detail_list" :key="item.id">
        <mtd-row :gutter="8">
          <mtd-col :span="19" style="padding-left: 0">
            <span class="detail-card-title">{{ item.filename }}</span>
          </mtd-col>
          <mtd-col :span="5">
            <mtdm-button class="card-title-btn" icon="mtdmicon-customer-o" type="text-primary" size="small"
                         @click="report(item)">{{ $getText('wenshu_mobile_report', '举报') }}
            </mtdm-button>
          </mtd-col>
          <mtdm-dialog v-model="reportModal" :show-cancel-button="true" :title="$getText('wenshu_mobile_report', '举报')" @confirm="submitReport">
            <mtdm-input type="textarea" v-model="form_data.reportReason" autosize :rows="3" :maxlength="200"
                        :placeholder="$getText('wenshu_mobile_please_enter_reason_for_reporting', '请填写举报原因')"/>
            <div slot="footer">
              <div class="mtdm-dialog-btn">
                <mtdm-button class="mtdm-dialog-confirm" type="text-primary" width="full" @click.stop="closeReport">
                  {{ $getText('wenshu_mobile_cancel', '取消') }}
                </mtdm-button>
                <mtdm-button class="mtdm-dialog-confirm mtdm-line-left" type="text-primary" width="full"
                             @click.stop="submitReport" :disabled="form_data.reportReason.trim() === ''">
                  {{ $getText('ws_mobile_confirm', '确认') }}
                </mtdm-button>
              </div>
            </div>
          </mtdm-dialog>
        </mtd-row>
        <mtd-form>
          <mtd-row>
            <mtd-col :span="22">
              <mtd-form-item :label-width="80" label="mis ID">
                <span class="form-font">{{ item.misidObj }}</span>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row>
            <mtd-col :span="22">
              <mtd-form-item :label-width="80" :label="$getText('wenshu_mobile_name', '姓名')">
                <span class="form-font">{{ item.nameObj }}</span>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row>
            <mtd-col :span="24">
              <mtd-form-item :label-width="80" :label="$getText('wenshu_mobile_organization_structure', '组织架构')">
                <span class="form-font">{{ item.orgPathNameObj }}</span>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row>
            <mtd-col :span="22">
              <mtd-form-item :label-width="80" :label="$getText('wenshu_mobile_data_source', '数据来源')">
                <span class="form-font">{{ item.sourceObj}}</span>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row>
            <mtd-col :span="22">
              <mtd-form-item :label-width="80" :label="$getText('wenshu_mobile_reason_for_reporting', '举报原因')">
                <span class="form-font">{{ item.reportReason}}</span>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row style="margin-top: 8px">
            <mtd-col :span="12">
              <mtdm-tag type="ghost" :textColor="item.tag | colorFilter" style="margin-left: 15px">
                {{ getI18nTag(item.tag) }}
              </mtdm-tag>
            </mtd-col>
            <mtd-col :span="12" class="operate-date">
              {{ $getText('wenshu_mobile_operation_time', '操作时间') }}：{{ item.operateStartTimeObj && item.operateStartTimeObj.substr(0, 10) }}
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-card>
    </div>
    <div style="width: 100%;background-color: #fff; padding-top: 5px;"
         v-if="alarm_detail_list.length !== query_params.tn">
      <mtdm-button type="text-primary" width="full" size="tiny" @click="change_page"
                   style="color: rgba(0, 0, 0, 0.24);">
        {{ $getText('ws_mobile_load_more', '加载更多') }}
      </mtdm-button>
    </div>
    <div style="width: 100%;background-color: #fff; padding-top: 5px;" v-if="alarm_detail_list.length === 0">
      <mtdm-button type="text-primary" width="full" size="tiny" style="color: rgba(0, 0, 0, 0.24);">
        {{ $getText('wenshu_web_no_data', '暂无数据') }}
      </mtdm-button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  import {mapActions} from 'vuex'

  export default {
    name: "alert_detail",
    filters: {
      colorFilter(operateType) {
        switch (operateType) {
          case '查看':
            return 'rgba(0,0,0,0.36)';
          case '转发':
            return '#F5483B';
          case '下载':
            return '#0A70F5';
          case '外发':
            return '#F78745';
        }
      },
    },
    data() {
      const today = new Date();
      const old = new Date();
      old.setTime(today.getTime() - 3600 * 1000 * 24 * 365 * 4);
      return {
        alarm_detail_list: [],
        reportModal: false,
        reason: '',
        screenShow: false,
        searchShow: false,
        operateTypeShow: false,
        operateDateShow: false,
        minDate: old,
        options: [
          {label: this.$getText('wenshu_mobile_view', '查看'), value: 1},
          {label: this.$getText('wenshu_mobile_forward', '转发'), value: 2},
          {label: this.$getText('wenshu_mobile_download', '下载'), value: 3},
          {label: this.$getText('wenshu_mobile_external_share', '外发'), value: 4}
        ],
        operateTypeValue: this.$getText('wenshu_mobile_please_select_operation_type', '请选择操作类型'),
        operateDateValue: this.$getText('wenshu_mobile_please_select_operation_time', '请选择操作时间'),
        query_params: {
          fileName: '',
          fileNameLike: '',
          operateTime: '',
          operateTypeShow: [],
          operateType: '',
          dataSource: null,
          queryDt: null,
          cn: 1, // 当前页面
          sn: 10, // 每页大小
          tn: 0 // 总条数
        },
        form_data: {
          detailId: null,
          fileMd5: null,
          fileName: null,
          misId: null,
          reportReason: ''
        }
      }
    },
    mounted: function () {
      document.title = this.$getText('wenshu_mobile_alert_details', '告警详情');

      // 1.首先获取传递的参数
      let filename = this.$route.params.filename;
      let dataSource = this.$route.params.dataSource;
      let queryDt = this.$route.params.queryDt;
      if (filename && filename !== '') {
        this.query_params.fileName = filename;
      }
      if (dataSource && dataSource !== '') {
        this.query_params.dataSource = dataSource;
      }
      if (queryDt && (/^\d{8}$/.test(queryDt))) {
        this.query_params.queryDt = queryDt;
      }
      this.reloadFirstPage();
    },
    methods: {
      // API方法
      ...mapActions({
        api_list_file_detail: 'api_file_trace_query_file_detail',
        api_file_detail_report: 'api_file_trace_file_detail_report',
      }),
      list_file_detail() {
        this.query_params.size = this.query_params.sn;
        this.query_params.page = this.query_params.cn;
        this.query_params.operateStartTime = null;
        this.query_params.operateEndTime = null;
        this.api_list_file_detail(this.query_params).then((res) => {
          if (res.code === 0) {
            let {currentPage, limit, total, items} = res.data;
            this.alarm_detail_list.push(...items);
            this.query_params.cn = currentPage;
            this.query_params.sn = limit;
            this.query_params.tn = total;
          } else {
            this.$mtd.message.error(this.$getText('wenshu_web_failed_to_get_data', '获取数据失败'));
          }
        });
      },
      change_page() {
        this.query_params.cn = this.query_params.cn + 1;
        this.list_file_detail();
      },
      report(row) {
        this.form_data.detailId = row.id;
        this.form_data.fileMd5 = row.filemd5;
        this.form_data.fileName = row.filename;
        this.form_data.misId = row.misid;
        this.reportModal = true;
      },
      reset() {
        this.operateTypeValue = this.$getText('wenshu_mobile_please_select_operation_type', '请选择操作类型');
        this.operateDateValue = this.$getText('wenshu_mobile_please_select_operation_time', '请选择操作时间');
        this.query_params.operateTime = '';
        this.query_params.operateType = '';
        this.query_params.operateTypeShow = [];
      },
      confirm(value, index) {
        this.operateTypeValue = this.options[index[0]].label;
        this.query_params.operateTypeShow = value;
        this.query_params.operateType = this.options[index[0]].label;
      },
      dateConfirm(value) {
        let dateValue = moment(value).utcOffset(480).format('YYYY-MM-DD');
        this.operateDateValue = dateValue;
        this.query_params.operateTime = dateValue;
      },
      closeReport() {
        this.form_data = {
          detailId: null,
          fileMd5: null,
          fileName: null,
          misId: null,
          reportReason: ''
        };
        this.reportModal = false;
      },
      submitReport() {
        if (!this.form_data.reportReason || this.form_data.reportReason === '') {
          return false;
        }
        this.api_file_detail_report(this.form_data).then(() => {
          this.closeReport();
          this.$mtdm.toast({
            message: this.$getText('wenshu_web_report_successful', '举报成功'),
            icon: 'mtdmicon-accept'
          });
          this.reloadFirstPage();
        });
      },
      // 返回列表页
      back() {
        this.$router.push({
          name: "mobile_file_trace_alert_list",
          query: {dataSource: this.query_params.dataSource, dt: this.query_params.queryDt}
        });
      },
      reloadFirstPage() {
        this.screenShow = false;
        this.searchShow = false;
        this.alarm_detail_list = [];
        this.query_params.cn = 1;
        this.list_file_detail();
      },
      getI18nTag(tag) {
        switch (tag) {
          case '查看':
            return this.$getText('wenshu_mobile_view', '查看');
          case '转发':
            return this.$getText('wenshu_mobile_forward', '转发');
          case '下载':
            return this.$getText('wenshu_mobile_download', '下载');
          case '外发':
            return this.$getText('wenshu_mobile_external_share', '外发');
        }
      }
    }
  }
</script>

<style>
  .detail-header {
    background-color: #F5F5F5;
    z-index: 3068;
  }

  .search-block {
    padding: 15px 7px;
    height: 52px;

  }

  .search-btn {
    font-family: PingFang SC, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.60);
    letter-spacing: 0;
    line-height: 22px;
    font-weight: 400;
    padding: 0 10px;
    height: 22px;
  }

  .detail-card-title {
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.84);
    letter-spacing: 0;
    font-weight: 500;
    line-height: 22px
  }

  .detail-card .mtd-form-item {
    margin-bottom: 0;
  }

  .detail-card .mtd-card {
    border-radius: 0;
  }

  .operate-date {
    font-family: PingFang SC, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.24);
    letter-spacing: 0;
    text-align: right;
    line-height: 20px;
    font-weight: 400;
  }

  .form-font {
    font-family: PingFang SC, sans-serif;
    font-size: 14px;
    color: #000000;
    font-weight: 400;
    line-height: 20px
  }

  .detail-card .mtd-form-item .mtd-form-item-label {
    text-align: left;
  }

  .mtdm-input {
    background: #F5F5F5;
  }

  .mtdm-input-wrapper textarea {
    background: #F5F5F5;
  }

  .mtd-input-wrapper.mtd-input-prefix .mtd-input {
    background: rgba(0, 0, 0, 0.04);
  }

  .mtdm-popup-top {
    top: 44px;
    z-index: 3000;
  }

  .mtdm-navbar-bar {
    z-index: 9999 !important;
  }

  .screen-title-font {
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: #8C8C8C;
    letter-spacing: 0;
    font-weight: 500;
    line-height: 22px
  }

  .select-div {
    margin-top: 8px;
    width: 100%;
    height: 32px;
    background: #F7F7F7;
    padding-left: 13px;
    padding-right: 9px;
    font-family: PingFang SC, sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.24);
    line-height: 22px;
    font-weight: 400;
  }

  .mtd-input {
    border-radius: 10px !important;
    border: none;
  }

  .keyword-list {
    font-family: PingFang SC, sans-serif;
    font-size: 17px;
    color: rgba(10, 112, 245, 1);
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 400;
  }
</style>
